import React from 'react';

const VerTiaj1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel}) => {
  const a013505 = autorizacUA.findIndex( autorizac => autorizac === "013505" );
  const a013510 = autorizacUA.findIndex( autorizac => autorizac === "013510" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a013505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a013510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerTiaj1
